import { ButtonBase as MuiButtonBase, ButtonBaseProps as MuiButtonBaseProps } from '@mui/material';
import { forwardRef } from 'react';

export type ButtonBaseProps = MuiButtonBaseProps;

/**
 * Thin wrapper over Material UI's `ButtonBase` — an unstyled, accessible button primitive
 * (keyboard focusable + activatable, with the focus ripple). Use it to make arbitrary
 * content (e.g. an image thumbnail) behave as a real button without inheriting button chrome.
 */
export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>((props, ref) => (
  <MuiButtonBase ref={ref} {...props} />
));

ButtonBase.displayName = 'ButtonBase';
